import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {Headers} from '@angular/http';
import {ContractLineItem} from '../../interfaces/ContractLineItem';
import {CalculationField} from '../../../form-builder/interfaces/CalculationField';

@Injectable()
export class ContractItemService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private contractItemUrl = 'contractitem';

  constructor(private http: AuthHttp) { }

    public getItemList(parentId: number) {
        const url = `${environment.baseUrl}${this.contractItemUrl}/${parentId}`;
        return this.http
            .get(url,  {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json() as ContractLineItem[];
            })
            .catch(this.handleError);
    }

    public create(newItem) {
        console.log(newItem);
        const url = `${environment.baseUrl}${this.contractItemUrl}`;
        return this.http
            .post(url, JSON.stringify(newItem), {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(this.handleError);
    }

    public createFieldItem(parentId: number, calculationField) {
        const url = `${environment.baseUrl}${this.contractItemUrl}/${parentId}`;
        return this.http
            .post(url, JSON.stringify(calculationField), {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json() as any[];
            })
            .catch(this.handleError);
    }

    public getFields(parentId: number) {
        const url = `${environment.baseUrl}${this.contractItemUrl}/${parentId}/fields`;
        return this.http
            .get(url,  {headers: this.headers})
            .toPromise()
            .then(response => {
                return response.json() as CalculationField[];
            })
            .catch(this.handleError);
    }

    public remove(id: number): Promise<void> {
        const url = `${environment.baseUrl}${this.contractItemUrl}/${id}`;
        return this.http
            .delete(url, {headers: this.headers})
            .toPromise()
            .then(() => null)
            .catch(this.handleError);
    }




    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/services/contract-item/contract-item-service.service.ts